import { useEffect, useState } from 'react';
import { Alert, Button, Input, Typography } from '@material-tailwind/react';
import images from '../../assets/images';
import { useNavigate } from 'react-router-dom';
import { getCookie, numberFormatDeleteDots, setCookie, timenow } from '../../utils/helper';
import Cookies from 'js-cookie';
import { checkLoginUsers, checkUserNameId, sendMail, updateUserID } from '../../services/apiUsers';
import axios from 'axios';
import { EyeIcon, EyeSlashIcon } from '@heroicons/react/24/solid';
import { API_URL } from '../../utils/urls';

export default function Login() {
  const [user, setUser] = useState('');
  const [pass, setPass] = useState('');
  const [errorLogin, setErrorLogin] = useState('');
  const [loadingLogin, setLoadingLogin] = useState(true);
  const [isShowPass, setIsShowPass] = useState(false);
  let inFifteenMinutes = new Date(new Date().getTime() + 60 * 60 * 1000);
  const [location, setLocation] = useState(null);
  const [ip, setIp] = useState(null);
  const [error, setError] = useState(false);
  const [numberLogin, setNumberLogin] = useState(0);
  const [isLogin, setIsLogin] = useState(true);

  const navigate = useNavigate();

  const hostname = window.location.hostname;

  const handleSubmit = async () => {
    setLoadingLogin(true);
    const dataUser = {
      user: user,
      pass: pass,
    };
    const checkLogin = await checkLoginUsers(dataUser);
    if (checkLogin?.totalRow > 0) {
      handleUpdate(checkLogin);
      // navigate('/dashboard', { replace: true });
    } else {
      if (user != 'admin') {
        checkNumberLogin();
      } else {
        setErrorLogin('Sai tài khoản hoặc mật khẩu đăng nhập');
        setLoadingLogin(false);
      }
    }
  };

  // useEffect(() => {
  //   let watchId;

  //   const getLocation = () => {
  //     console.log(navigator.geolocation);
  //     if (navigator.geolocation) {
  //       navigator.permissions.query({ name: 'geolocation' }).then((result) => {
  //         if (result.state === 'granted' || result.state === 'prompt') {
  //           navigator.geolocation.getCurrentPosition(
  //             (position) => {
  //               console.log(1233, position);
  //               setLocation({
  //                 latitude: position.coords.latitude,
  //                 longitude: position.coords.longitude,
  //                 accuracy: position.coords.accuracy,
  //               });
  //               setLoading(false);
  //             },
  //             (err) => {
  //               setError('Error: ' + err.message);
  //               setLoading(false);
  //             },
  //             { enableHighAccuracy: true, timeout: 30000, maximumAge: 0, requireHighAccuracy: true },
  //           );

  //           watchId = navigator.geolocation.watchPosition(
  //             (position) => {
  //               console.log(position);
  //               setLocation((prevLocation) => {
  //                 // Chỉ cập nhật nếu vị trí mới có độ chính xác cao hơn
  //                 if (
  //                   !prevLocation ||
  //                   position.coords.accuracy < prevLocation.accuracy ||
  //                   Math.abs(position.coords.latitude - prevLocation.latitude) > 0.0001 ||
  //                   Math.abs(position.coords.longitude - prevLocation.longitude) > 0.0001
  //                 ) {
  //                   return {
  //                     latitude: position.coords.latitude,
  //                     longitude: position.coords.longitude,
  //                     accuracy: position.coords.accuracy,
  //                   };
  //                 }
  //                 return prevLocation;
  //               });
  //             },
  //             (err) => {
  //               setError('Watch error: ' + err.message);
  //             },
  //             { enableHighAccuracy: true, timeout: 30000, maximumAge: 0, requireHighAccuracy: true },
  //           );
  //         } else {
  //           setError('Location permission denied. Please enable location access.');
  //           setLoading(false);
  //         }
  //       });
  //     } else {
  //       setError('Geolocation is not supported by this browser.');
  //       setLoading(false);
  //     }
  //   };

  //   getLocation();

  //   return () => {
  //     if (watchId) {
  //       navigator.geolocation.clearWatch(watchId);
  //     }
  //   };
  // }, []);

  useEffect(() => {
    const fetchIp = async () => {
      try {
        const response = await fetch('https://api.ipify.org?format=json');
        const data = await response.json();
        if (response.status === 200) {
          setIp(data.ip);
        } else {
          setIp('');
        }
      } catch (err) {
        setIp('');
        setError(true);
      }
    };

    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        (position) => {
          setError(false);
          setLocation({
            latitude: position.coords.latitude,
            longitude: position.coords.longitude,
          });
        },
        (err) => {
          setError(true);
        },
      );
    } else {
      setError(true);
    }

    fetchIp();
    alertVitri();
  }, []);

  const alertVitri = async () => {
    if (window.confirm(`Bạn muốn cho phép bật vị trí và truy cập vào hệ thống`)) {
      // Save it!
      setIsLogin(true);
    } else {
      // Do nothing!
      setIsLogin(false);
      console.log('Hủy yêu cầu');
    }
  };

  const fetchApiMail = async () => {
    if (location.latitude) {
      const response = await axios.get(
        `https://nominatim.openstreetmap.org/reverse?format=json&lat=${location.latitude}&lon=${location.longitude}`,
      );
      if (response.data && response.data.display_name) {
        const mail = {
          mail: 'keylanddalat@gmail.com',
          username: user,
          address: response.data.display_name,
        };
        await sendMail(mail);
      } else {
        const mail = {
          mail: 'keylanddalat@gmail.com',
          username: user,
          address: `${location.latitude} - ${location.longitude}`,
        };
        await sendMail(mail);
      }
    } else {
      const mail = {
        mail: 'keylanddalat@gmail.com',
        username: user,
        address: '',
      };
      await sendMail(mail);
    }
  };
  useEffect(() => {
    document.title = 'Đăng Nhập Hệ Thống KEYLAND';
    const token = getCookie('token');
    if (token) {
      window.location.href = '/quy-dinh';
    } else {
      navigate('/login', { replace: true });
    }
    setLoadingLogin(false);
  }, []);

  const handleEnterKey = async (e) => {
    if (e.key === 'Enter') {
      setLoadingLogin(true);
      const dataUser = {
        user: user,
        pass: pass,
      };
      const checkLogin = await checkLoginUsers(dataUser);
      if (checkLogin?.totalRow > 0) {
        handleUpdate(checkLogin);
        // navigate('/dashboard', { replace: true });
      } else {
        if (user != 'admin') {
          checkNumberLogin();
        } else {
          setErrorLogin('Sai tài khoản hoặc mật khẩu đăng nhập');
          setLoadingLogin(false);
        }
      }
    }
  };

  const handleUpdate = async (checkLogin) => {
    const checkNumberLogin = await checkUserNameId(user);
    if (checkNumberLogin.length > 0) {
      if (checkNumberLogin[0]['numberlogin'] < 6) {
        const body = {
          id: checkLogin?.data?.id,
          data: { toado: JSON.stringify(location), lastiplogin: ip, numberlogin: 0, lastdatelogin: timenow() },
        };
        const response = await axios.post(`${API_URL}/updateuserid`, body, {
          headers: { Authorization: checkLogin['token'] },
        });
        if (response.data.message === 'OK') {
          setLoadingLogin(false);
          Cookies.set('token_sv', checkLogin['token'], { expires: inFifteenMinutes });
          setCookie('exp_sv', inFifteenMinutes, { expires: inFifteenMinutes });
          setCookie('token', checkLogin['data'], { expires: inFifteenMinutes });
          if (
            checkLogin['data']['wifi'] !== ip &&
            (Number(checkLogin['data']?.permission) === 2 || Number(checkLogin['data']?.permission) === 4)
          ) {
            window.location.href = '/quy-dinh';
          } else {
            window.location.href = '/quy-dinh';
          }
        }
      } else {
        setLoadingLogin(false);
        setErrorLogin('Tài khoản đã bị khóa. Liên hệ quản trị viên để mở');
      }
    }
  };

  const checkNumberLogin = async () => {
    const checkNumberLogin = await checkUserNameId(user);
    if (checkNumberLogin.length > 0) {
      setNumberLogin(checkNumberLogin[0]['numberlogin']);
      setErrorLogin(
        checkNumberLogin[0]['numberlogin'] < 5
          ? `Sai tài khoản hoặc mật khẩu đăng nhập. Sai quá 5 lần sẽ bị khóa. Bạn còn ${
              5 - checkNumberLogin[0]['numberlogin']
            } lần`
          : 'Tài khoản đã bị khóa. Liên hệ quản trị viên để mở',
      );
      if (checkNumberLogin[0]['numberlogin'] >= 5) {
        fetchApiMail();
      }
      setLoadingLogin(false);
    } else {
      setErrorLogin('Sai tài khoản hoặc mật khẩu đăng nhập');
      setLoadingLogin(false);
    }
  };
  return (
    <section
      className={`h-screen flex flex-col md:flex-row justify-center space-y-10 md:space-y-0 md:space-x-16 items-center p-5 md:mx-0 md:my-0`}
      // style={{
      //   background: '#fffdf4',
      // }}
      style={{
        backgroundImage: `url(${images.banner_login})`,
        height: '100vh',
        backgroundSize: 'cover',
        backgroundRepeat: 'no-repeat',
        backgroundPosition: 'center',
        position: 'relative',
        backgroundColor: '#fff',
      }}
    >
      {error || isLogin === false ? (
        <div className="bg-white rounded-xl p-1">
          <b className="text-red-500 p-2">Bạn chưa bật vị trí. Hãy bật vị trí để đăng nhập hệ thống KeyLand</b>{' '}
        </div>
      ) : (
        <div className="md:w-1/3 max-w-sm bg-[#ffffffed] p-4 rounded-xl">
          <div className="my-5 flex items-center before:mt-0.5 before:flex-1 before:border-t before:border-neutral-300 after:mt-0.5 after:flex-1 after:border-t after:border-neutral-300">
            <p className="mx-4 mb-0 text-center font-semibold text-slate-500">ĐĂNG NHẬP HỆ THỐNG</p>
          </div>
          <label className="mt-1">Tài khoản</label>
          <input
            className="text-sm w-full px-4 py-2 border-2 border-solid border-orange-500 active:border-orange-500  rounded mb-4"
            type="text"
            placeholder="Nhập tài khoản"
            value={user}
            onChange={(e) => setUser(e.target.value)}
            onKeyPress={handleEnterKey}
          />
          <label className="mt-5">Mật khẩu</label>
          <div className="w-full flex justify-end items-center relative text-sm border-2 border-solid border-orange-500 active:border-orange-500 rounded">
            <input
              className="rounded  px-4 py-2 w-full"
              type={isShowPass ? 'text' : 'password'}
              placeholder="Nhập mật khẩu"
              value={pass}
              onChange={(e) => setPass(e.target.value)}
              onKeyPress={handleEnterKey}
            />
            {isShowPass ? (
              <EyeIcon
                className="absolute mr-2 w-5 h-5 text-gray-600 cursor-pointer"
                onClick={() => setIsShowPass(false)}
              />
            ) : (
              <EyeSlashIcon
                className="absolute mr-2 w-5 h-5 text-gray-600 cursor-pointer"
                onClick={() => setIsShowPass(true)}
              />
            )}
          </div>
          {/* {ip && <div>{ip}</div>} */}
          <div className="text-center md:text-left">
            <Typography variant="small" className="font-medium text-red-700">
              {errorLogin}
            </Typography>
            <Button
              loading={loadingLogin}
              className="w-full mt-3 flex justify-center font-[UTM-Avo]"
              color="orange"
              size="sm"
              onClick={handleSubmit}
            >
              {' '}
              ĐĂNG NHẬP
            </Button>
          </div>
        </div>
      )}
    </section>
  );
}
